export interface IGeoPoint {
	coordinates: [number, number]
	type: string
}

export interface ICMSLocation {
	id: number
	place_id: string
	main_cms_location_id: number | null
	geo_point: IGeoPoint | null
	is_active_pl: boolean
	is_active_en: boolean
	is_active_de: boolean | null
	is_active_es: boolean | null
	is_active_fr: boolean | null
	is_active_sk: boolean | null
	is_active_cs: boolean | null
	custom_menu_item: boolean
	show_on_locations: boolean
	show_in_menu: boolean
	show_in_footer: boolean
	other_location: boolean
	delivery_bus: boolean
	passenger_bus: boolean
	icon: string | null
	email: string | null
	phone_number: string | null
	name_pl: string
	name_en: string
	name_de: string | null
	name_es: string | null
	name_fr: string | null
	name_sk: string | null
	name_cs: string | null
	subtitle_pl: string | null
	subtitle_en: string | null
	subtitle_de: string | null
	subtitle_es: string | null
	subtitle_fr: string | null
	subtitle_sk: string | null
	subtitle_cs: string | null
	address_pl: string | null
	address_en: string | null
	address_de: string | null
	address_es: string | null
	address_fr: string | null
	address_sk: string | null
	address_cs: string | null
	url_pl: string
	url_en: string
	url_de: string | null
	url_es: string | null
	url_fr: string | null
	url_sk: string | null
	url_cs: string | null
	created_at: string
	updated_at: string
}

export interface ICMSLocationModel {
	id: number
	placeId: string
	mainCmsLocationId: number | null
	geoPoint: IGeoPoint | null
	isActivePL: boolean
	isActiveEN: boolean
	isActiveDE: boolean | null
	isActiveES: boolean | null
	isActiveFR: boolean | null
	isActiveSK: boolean | null
	isActiveCS: boolean | null
	customMenuItem: boolean
	showOnLocations: boolean
	showInMenu: boolean
	showInFooter: boolean
	otherLocation: boolean
	deliveryBus: boolean
	passengerBus: boolean
	icon: string | null
	email: string | null
	phoneNumber: string | null
	namePL: string
	nameEN: string
	nameDE: string | null
	nameES: string | null
	nameFR: string | null
	nameSK: string | null
	nameCS: string | null
	subtitlePL: string | null
	subtitleEN: string | null
	subtitleDE: string | null
	subtitleES: string | null
	subtitleFR: string | null
	subtitleSK: string | null
	subtitleCS: string | null
	addressPL: string | null
	addressEN: string | null
	addressDE: string | null
	addressES: string | null
	addressFR: string | null
	addressSK: string | null
	addressCS: string | null
	urlPL: string
	urlEN: string
	urlDE: string | null
	urlES: string | null
	urlFR: string | null
	urlSK: string | null
	urlCS: string | null
	createdAt: string
	updatedAt: string
}

export type SupportedCMSLocationLocale = 'PL' | 'EN'

export const getCMSLocationIsActiveKey = (locale: string): `isActive${SupportedCMSLocationLocale}` =>
	`isActive${locale.toUpperCase() as SupportedCMSLocationLocale}`

export type TMainSectionSave = () => Promise<boolean>
export type TRegisterMainSectionSave = (save: TMainSectionSave | null) => void
